import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface OnboardingHeaderProps {
  currentStep: number;
  totalSteps: number;
  onBack: () => void;
  showBack?: boolean;
}

const OnboardingHeader: React.FC<OnboardingHeaderProps> = ({
  currentStep,
  totalSteps,
  onBack,
  showBack = true
}) => {
  return (
    <div className="flex items-center justify-between p-4 bg-white border-b border-gray-100">
      <div className="flex items-center gap-3">
        {showBack && (
          <Button
            variant="ghost"
            size="icon"
            onClick={onBack}
            className="h-8 w-8 text-gray-600 hover:text-gray-900"
          >
            <ArrowLeft className="h-4 w-4" />
          </Button>
        )}
        <img 
          src="/lovable-uploads/120101b5-df74-479f-bfcb-7643f8fd8af8.png" 
          alt="LovaBuild" 
          className="h-8 w-auto"
        />
      </div>
      
      {currentStep > 1 && currentStep <= 9 && (
        <div className="text-sm text-gray-500 font-medium">
          {currentStep <= 8 ? currentStep - 1 : currentStep === 9 ? 8 : 8}/8
        </div>
      )}
    </div>
  );
};

export default OnboardingHeader;